import {
  ArrowLeftOutlined
} from "@ant-design/icons";

import {
  useEffect
} from "react";

import {
  useNavigate
} from "react-router-dom";

import {
  useDevice
} from "../../hooks";

export default function AccountShell({
  title,
  description,
  children,
  action
}) {
  const navigate = useNavigate();
  const { isMobile } = useDevice();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }, []);


  return (
    <div
      className={`
        min-h-screen
        bg-[#f5f7fb]
        ${isMobile ? "pb-28" : "py-7"}
      `}
    >
      <div
        className="
          max-w-5xl
          mx-auto
          px-3
          md:px-6
        "
      >
        <button
          type="button"
          onClick={() =>
            navigate("/thong-tin-ca-nhan")
          }
          className="
            border-0
            bg-transparent
            p-0
            mb-4
            text-blue-600
            font-semibold
            text-[13px]
            flex
            items-center
            gap-2
          "
        >
          <ArrowLeftOutlined />
          Trở lại Tài khoản
        </button>

        <div
          className="
            bg-white
            rounded-[24px]
            border
            border-slate-100
            shadow-[0_10px_35px_rgba(15,23,42,0.05)]
            overflow-hidden
          "
        >
          <div
            className="
              px-5 py-5
              md:px-7 md:py-6
              border-b
              border-slate-100
              flex
              items-center
              justify-between
              gap-4
            "
          >
            <div>
              <h1
                className="
                  text-[21px]
                  md:text-[25px]
                  font-bold
                  text-slate-900
                  m-0
                "
              >
                {title}
              </h1>

              {description && (
                <p
                  className="
                    text-[12px]
                    md:text-[13px]
                    text-slate-400
                    mt-1
                    mb-0
                  "
                >
                  {description}
                </p>
              )}
            </div>

            {action}
          </div>

          <div
            className="
              p-4
              md:p-7
            "
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
